module.exports = __webpack_public_path__ + "img/leslie_stevens.2ef54447.jpg";